import FanBugPage from "./FanBugPage";

export default FanBugPage;